import React from 'react'
import { Badge } from '../common/Badge/Badge'
import { TicketVariant } from '../../interfaces/models/ticket.interfaces'
import { useAppTranslation } from '../../hooks/useAppTranslation'

export const TicketVariantBadge = ({
  variant,
}: {
  variant: TicketVariant
}): React.ReactNode => {
  const { translate } = useAppTranslation()
  return (
    <Badge
      padding="px-1.5"
      colorClass={variant === 'report' ? 'bg-amber-100' : 'bg-sky-100'}
      borderColorClass={
        variant === 'report' ? 'border-amber-500' : 'border-sky-500'
      }
      textColorClass="text-black"
      text={translate(`ticket.variant.${variant}`)}
      className="h-5 w-fit"
    />
  )
}
